import { useTranslation } from 'react-i18next';
import PageHeader from '@/components/page-header';
import { setWebTitle } from '@/lib/format-utils';
import ServiceGroupsEditList from '@/components/service-groups-edit-list';
import { useServiceGroups } from '@/hooks/api-hooks';
import { SkeletonList } from '@/components/snippets';


export default function ServiceGroupsPage(): JSX.Element {
    const { t } = useTranslation();

    setWebTitle(t('service_groups'));

    const {
        isLoading,
        data
    } = useServiceGroups();
    const serviceGroups = data?.data || [];

    return (
        <div>
            <PageHeader
                title={t('service_groups')}
            />

            <div className="panel-content">
                {isLoading ? (
                    <SkeletonList />
                ) : (
                    <ServiceGroupsEditList
                        serviceGroups={serviceGroups}
                        isLoading={isLoading}
                    />
                )}
            </div>
        </div>
    );
}
